import Fetcher from "./Shared/FetchService";
// import { type Team } from "../Domain/Engagement/Team.model";
const reportUrl = "/aviso/report/";
export default class ReportService {
    static getAccessibleReports() {
        return Fetcher.getSingleResponse(reportUrl + "accessibleReports");
    }
}
